module.exports = __webpack_public_path__ + "static/media/minus.ff8238aa.svg";